/**
 * Bootstrap labels for the trigger picker, shown before the server registry
 * (/api/social/triggers) resolves. The server registry is the source of truth;
 * this is only a first-paint fallback so the picker is never blank. Keys mirror
 * server/services/social/graph/triggers.js.
 */
export const TRIGGER_LABELS = {
    listing_published: 'Pferde-Profil veröffentlicht',
    listing_reactivated: 'Pferde-Profil reaktiviert',
    rider_available: 'Reiter verfügbar',
    rider_reactivated: 'Reiter-Profil reaktiviert',
    rider_not_confirmed: 'Reiter-Profil nicht bestätigt',
};
